import React, {FunctionComponent, useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Col} from "@pg-design/grid-module";
import {flex, mv, pb, prettyScroll} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Tabs} from "@pg-design/tabs";
import {RequestState} from "@pg-mono/request-state";

import {ColumnList} from "../../../atoms/ColumnList";
import {OfferBox} from "../../../offer/components/offer_box/OfferBox";
import {showOfferModal} from "../../../offer/state/offer_modals_slice";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {IVendorOffer} from "../../../offer/types/VendorOffer";
import {Country} from "../../../region/types/Country";
import {fetchVendorDetailOffersByRegion} from "../../actions/fetch_vendor_detail_offers";
import {VendorDetailOfferModal} from "./VendorDetailOfferModal";

interface IProps {
    offers: IVendorOffer[];
    offersInRegion: IVendorOffer[];
    vendor: {
        id: number;
        stats: {
            offers_count_for_sale: number;
            properties_count_for_sale: number;
        };
    };
    cities: {
        id: number;
        name: string;
    }[];
    openMapBtnClick: () => void;
    offersInRegionRequest: RequestState;
}

const modalName: IOfferModalName = "mainOfferModal";

export const VendorDetailActiveOffers: FunctionComponent<IProps> = React.memo((props) => {
    const {offers, offersInRegion, offersInRegionRequest, cities} = props;
    const dispatch = useDispatch();

    //  City change
    const [selectedCity, setSelectedCity] = useState<number | null>(null);
    const changeRegion = useCallback(
        (regionId: number) => {
            // when `regionId` is the same we do NOT toggle button
            if (regionId === selectedCity) {
                return;
            }

            const regionIdNormalized = regionId === -1 ? null : regionId;
            // fetch proper list
            fetchVendorDetailOffersByRegion(props.vendor.id, regionIdNormalized)(dispatch);
            setSelectedCity(regionIdNormalized);
        },
        [props.vendor.id, selectedCity]
    );

    const canDisplayResults = selectedCity === null || (selectedCity && offersInRegionRequest === RequestState.Success);
    const offersToDisplay = selectedCity === null ? offers : offersInRegion;

    return (
        <>
            <div css={filterTabsHolder}>
                {cities.length > 1 && (
                    <Tabs<number>
                        color="gray"
                        variant="contained"
                        fullWidth
                        onChange={changeRegion}
                        value={selectedCity ?? -1}
                        tabs={[
                            {
                                title: "Wszystkie",
                                value: -1
                            },
                            ...cities.map((region) => ({
                                title: region.name,
                                value: region.id
                            }))
                        ]}
                    />
                )}
            </div>

            <ColumnList fluid css={offerListWrapper}>
                {canDisplayResults &&
                    offersToDisplay.map((offer, index) => (
                        <Col key={offer.id} sm={4} md={4} as="li" css={[flex("normal", "center")]}>
                            <OfferBox
                                offer={offer}
                                onShowOfferDetailsBtnClick={() => {
                                    dispatch(showOfferModal({modalName, offerId: offer.id}));
                                }}
                                unlinkVendor
                                fetchPriority={index === 0 ? "high" : "auto"}
                                showFullPrice={offer.region.country === Country.SPAIN}
                            />
                        </Col>
                    ))}
            </ColumnList>

            {offersInRegionRequest === RequestState.Waiting && (
                <div css={loaderHolder}>
                    <Loader size="md" />
                </div>
            )}

            <VendorDetailOfferModal vendorId={props.vendor.id} />
        </>
    );
});

const loaderHolder = css`
    display: flex;
    justify-content: center;
`;

const filterTabsHolder = (theme: Theme) => css`
    overflow-x: auto;
    overflow-y: hidden;
    ${pb(1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${prettyScroll()};
    }
`;

const offerListWrapper = (theme: Theme) => css`
    ${mv(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mv(4)};
    }
`;
import React, {FunctionComponent, useCallback, useState} from "react";
import {useDispatch} from "react-redux";
import {css, Theme} from "@emotion/react";

import {Col} from "@pg-design/grid-module";
import {flex, mv, pb, prettyScroll} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {Tabs} from "@pg-design/tabs";
import {RequestState} from "@pg-mono/request-state";

import {ColumnList} from "../../../atoms/ColumnList";
import {OfferBox} from "../../../offer/components/offer_box/OfferBox";
import {showOfferModal} from "../../../offer/state/offer_modals_slice";
import {IOfferModalName} from "../../../offer/types/OfferModalName";
import {IVendorOffer} from "../../../offer/types/VendorOffer";
import {Country} from "../../../region/types/Country";
import {fetchVendorDetailOffersByRegion} from "../../actions/fetch_vendor_detail_offers";
import {VendorDetailOfferModal} from "./VendorDetailOfferModal";

interface IProps {
    offers: IVendorOffer[];
    offersInRegion: IVendorOffer[];
    vendor: {
        id: number;
        stats: {
            offers_count_for_sale: number;
            properties_count_for_sale: number;
        };
    };
    cities: {
        id: number;
        name: string;
    }[];
    openMapBtnClick: () => void;
    offersInRegionRequest: RequestState;
}

const modalName: IOfferModalName = "mainOfferModal";

export const VendorDetailActiveOffers: FunctionComponent<IProps> = React.memo((props) => {
    const {offers, offersInRegion, offersInRegionRequest, cities} = props;
    const dispatch = useDispatch();

    //  City change
    const [selectedCity, setSelectedCity] = useState<number | null>(null);
    const changeRegion = useCallback(
        (regionId: number) => {
            // when `regionId` is the same we do NOT toggle button
            if (regionId === selectedCity) {
                return;
            }

            const regionIdNormalized = regionId === -1 ? null : regionId;
            // fetch proper list
            fetchVendorDetailOffersByRegion(props.vendor.id, regionIdNormalized)(dispatch);
            setSelectedCity(regionIdNormalized);
        },
        [props.vendor.id, selectedCity]
    );

    const canDisplayResults = selectedCity === null || (selectedCity && offersInRegionRequest === RequestState.Success);
    const offersToDisplay = selectedCity === null ? offers : offersInRegion;

    return (
        <>
            <div css={filterTabsHolder}>
                {cities.length > 1 && (
                    <Tabs<number>
                        color="gray"
                        variant="contained"
                        fullWidth
                        onChange={changeRegion}
                        value={selectedCity ?? -1}
                        tabs={[
                            {
                                title: "Wszystkie",
                                value: -1
                            },
                            ...cities.map((region) => ({
                                title: region.name,
                                value: region.id
                            }))
                        ]}
                    />
                )}
            </div>

            <ColumnList fluid css={offerListWrapper}>
                {canDisplayResults &&
                    offersToDisplay.map((offer, index) => (
                        <Col key={offer.id} sm={4} md={4} as="li" css={[flex("normal", "center")]}>
                            <OfferBox
                                offer={offer}
                                onShowOfferDetailsBtnClick={() => {
                                    dispatch(showOfferModal({modalName, offerId: offer.id}));
                                }}
                                unlinkVendor
                                fetchPriority={index === 0 ? "high" : "auto"}
                                showFullPrice={offer.region.country === Country.SPAIN}
                            />
                        </Col>
                    ))}
            </ColumnList>

            {offersInRegionRequest === RequestState.Waiting && (
                <div css={loaderHolder}>
                    <Loader size="md" />
                </div>
            )}

            <VendorDetailOfferModal vendorId={props.vendor.id} />
        </>
    );
});

const loaderHolder = css`
    display: flex;
    justify-content: center;
`;

const filterTabsHolder = (theme: Theme) => css`
    overflow-x: auto;
    overflow-y: hidden;
    ${pb(1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${prettyScroll()};
    }
`;

const offerListWrapper = (theme: Theme) => css`
    ${mv(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mv(4)};
    }
`;
